import React from "react";
import { Link } from "react-router-dom";
import "./start.css";

const Start = ({title, url})  => {
    return (
      <main>
        <div>
          <img
            src={require("../../../assets/images/start-interview.webp")}
            alt="Interview start background"
            className="start-img"
            loading="eager"
          />
            <div className="center pt-78">
                <h1 className="text-uppercase pb-2 text-white fw-bold start-title">{title}</h1>
                <Link to={url} className="start-btn bg-black text-white fw-bold rounded-4 p-3">Start Interview</Link>
            </div>
        </div>
      </main>
    );
    
}

export default Start;